export const environment = {
	production: true,
	featureFlagUrl: '/settings.js',
	env: 'production',
	apiBaseUrl: '/api/v2',
	ltiBaseUrl: '/lti',
	translationsPrefix: 'https://staticassets.goreact.com/eu-client/app/'
};
